import gsap from 'gsap';

class Filter {
  constructor(el) {
    this.el = el;
    this.previousActive = false;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  bindUI() {
    this.buttons = this.el.querySelectorAll('.js-filter-button');
    this.artworkList = this.el.querySelector('.js-artwork-list');
    this.previousHeight = this.artworkList.scrollHeight;
  }

  bindEvents() {
    if (this.buttons) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.filter.bind(this));
      });
    }
  }
  filter(e) {
    let animate = [];
    if (e.currentTarget.classList.contains('active')) {
      this.artworkList.querySelectorAll('.js-art-link').forEach((link) => {
        link.style.display = 'flex';
        animate.push(link);
      });
      e.currentTarget.classList.remove('active');
    } else {
      e.currentTarget.classList.add('active');
      if (this.previousActive && this.previousActive !== e.currentTarget) {
        this.previousActive.classList.remove('active');
      }
      this.previousActive = e.currentTarget;
      this.artworkList.querySelectorAll('.js-art-link').forEach((link) => {
        if (
          link.getAttribute('data-status') ===
          e.currentTarget.getAttribute('data-status')
        ) {
          link.style.display = 'flex';
          animate.push(link);
        } else {
          link.style.display = 'none';
        }
      });
    }
    if (animate.length) {
      gsap.to(animate, {
        x: 20,
        opacity: 0,
        duration: 0,
      });
      gsap.to(animate, {
        x: 0,
        opacity: 1,
        duration: 0.3,
        stagger: {
          each: 0.1,
          from: 'start',
          ease: 'power2.inOut',
        },
      });
    }
  }
}

export default Filter;
